var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "green", dense: "", flat: "", dark: "" }
                    },
                    [_c("span", [_vm._v("Budget Code Form")])]
                  ),
                  _c("v-container", [_c("budget-code-create")], 1)
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "green", dense: "", flat: "", dark: "" }
                    },
                    [_c("span", [_vm._v("Budget Code List")])]
                  ),
                  _c("v-container", [_c("budget-code-table")], 1)
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }